<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <div
      class="doc-paper preview keirekisho"
      :id="idPrefix + 'preview-page-01'"
    >
      <div class="keirekisho-wapper">
        <div class="keirekisho-header">
          <h1 class="title">職務経歴書</h1>
          <div
            class="date data text-right"
            :data-highlight="highlightMessage"
            @click="goCardTo('create-date')"
            :class="highLightClass('create-date')"
          >
            <span v-html="formatedCreateDate"></span>
          </div>
          <div
            class="data text-right"
            :data-highlight="highlightMessage"
            @click="goCardTo('profile')"
            :class="highLightClass('profile')"
          >
            <span class="name"
              >{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</span
            >
          </div>
        </div>
        <div class="keirekisho-content">
          <h2 v-if="formatData.jobSummary">経歴要約</h2>
          <div
            class="job-summary"
            :data-highlight="highlightMessage"
            @click="goCardTo('job-summary')"
            :class="highLightClass('job-summary')"
          >
            <pre :style="formatData.selFontStyle">{{
              formatData.jobSummary
            }}</pre>
          </div>
          <h2
            v-if="formatData.skillsToUse && formatData.skillsToUse.length"
            id="skills"
          >
            活かせるスキル・経験
          </h2>
          <div
            class="skills-to-use"
            :data-highlight="highlightMessage"
            @click="goCardTo('skills-to-use')"
            :class="highLightClass('skills-to-use')"
          >
            <dl
              v-for="(item, index) in formatData.skillsToUse"
              :key="index"
              :style="formatData.selFontStyle"
            >
              <dt>
                {{ item.skillname }}
                <template v-if="item.years"
                  >/ 実務経験 {{ item.years }}年以上</template
                >
              </dt>
              <dd>{{ item.description }}</dd>
            </dl>
          </div>
          <h2
            v-if="formatData.jobHistories && formatData.jobHistories.length"
            id="job-history"
          >
            職務経歴
          </h2>
          <div
            class="job-history"
            :data-highlight="highlightMessage"
            @click="goCardTo('job-history')"
            :class="highLightClass('job-history')"
          >
            <div v-for="item in formatData.jobHistories" :key="item.uuid">
              <h3
                v-if="
                  item.companyName ||
                  item.startYear ||
                  item.startMonth ||
                  item.endYear ||
                  item.endMonth
                "
                class="company-name"
                :style="formatData.selFontStyle"
              >
                {{ item.companyName }}
                <span
                  v-if="item.isContinuing && item.startYear && item.startMonth"
                  >{{ item.startYear }}年 {{ item.startMonth }}月 〜
                  在職中</span
                >
                <span
                  v-else-if="
                    item.isContinuing && item.startYear && !item.startMonth
                  "
                  >{{ item.startYear }}年 〜 在職中</span
                >
                <span
                  v-else-if="
                    item.isContinuing && !item.startYear && item.startMonth
                  "
                  >{{ item.startMonth }}月 〜 在職中</span
                >
                <span
                  v-else-if="
                    item.isContinuing && !item.startYear && !item.startMonth
                  "
                  >在職中</span
                >
                <span v-else
                  ><template v-if="item.startYear"
                    >{{ item.startYear }}年</template
                  >
                  <template v-if="item.startMonth"
                    >{{ item.startMonth }}月</template
                  >
                  <template v-if="item.endYear || item.endMonth">〜</template>
                  <template v-if="item.endYear">{{ item.endYear }}年</template>
                  <template v-if="item.endMonth"
                    >{{ item.endMonth }}月</template
                  ></span
                >
              </h3>
              <!-- <h3>{{ item.companyName }}<span>{{ item.startYear}}年{{ item.startMonth }}月 〜 現在に至る</span></h3> -->
              <div
                class="organization"
                v-if="
                  item.businessArea ||
                  item.numberOfEmployees ||
                  item.capitalStock
                "
                :style="formatData.selFontStyle"
              >
                <!-- prettier-ignore -->
                <pre v-if="item.businessArea" :style="formatData.selFontStyle">事業内容：{{ item.businessArea}}</pre>
                <p v-if="item.capitalStock && item.numberOfEmployees">
                  資本金：{{ item.capitalStock }}万円、従業員数：{{
                    item.numberOfEmployees
                  }}名
                </p>
                <p v-else-if="item.capitalStock && !item.numberOfEmployees">
                  資本金：{{ item.capitalStock }}万円
                </p>
                <p v-else-if="!item.capitalStock && item.numberOfEmployees">
                  従業員数：{{ item.numberOfEmployees }}名
                </p>
              </div>
              <h4
                v-if="
                  item.projects &&
                  item.projects.length &&
                  !formatData.notDisplayOmonajiseki
                "
              >
                主な実績
              </h4>
              <div
                v-for="(item, index) in item.projects"
                :key="index"
                :style="formatData.selFontStyle"
              >
                <h5
                  v-if="
                    item.projectTitle ||
                    item.startYear ||
                    item.startMonth ||
                    item.endYear ||
                    item.endMonth
                  "
                >
                  {{ item.projectTitle
                  }}<span
                    ><template v-if="item.startYear"
                      >{{ item.startYear }}年</template
                    >
                    <template v-if="item.startMonth"
                      >{{ item.startMonth }}月</template
                    >
                    <template v-if="item.endYear || item.endMonth">〜</template>
                    <template v-if="item.endYear"
                      >{{ item.endYear }}年</template
                    >
                    <template v-if="item.endMonth"
                      >{{ item.endMonth }}月</template
                    ></span
                  >
                </h5>
                <pre :style="formatData.selFontStyle">{{
                  item.contentsOfProject
                }}</pre>
              </div>
            </div>
          </div>

          <h2 v-if="formatData.prMessage">自己PR</h2>
          <div
            v-if="formatData.prMessage"
            class="prMessage"
            id="pr-message"
            :data-highlight="highlightMessage"
            @click="goCardTo('pr-message')"
            :class="highLightClass('pr-message')"
          >
            <!-- <div class="label">{{ currentCardId }} {{ isCardChanged }}testtesttest</div> -->
            <pre :style="formatData.selFontStyle">{{
              formatData.prMessage
            }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShokurekishoPreviewMixin from '@/mixins/shokurekisho-preview-mixin'
export default {
  name: 'shokurekishoPreview',
  mixins: [ShokurekishoPreviewMixin],
  data: function () {
    return {}
  },
  methods: {
    checkValid: function () {}
  }
}
</script>
